export const SET_EQUIPMENT_SN = 'SET_EQUIPMENT_SN' // SN列表
export const SET_EQUIPMENT_ARRAY = 'SET_EQUIPMENT_ARRAY' // 硬件设备列表
